import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Loader } from "../../components/Loader/Loader";
import { AppDispatch, RootState } from "../../store";
import { getPostCategories } from "../../store/slices/postCategoriesSlice";
import { getPosts } from "../../store/slices/postsSlice";
import { Section, TitleH1 } from "../../styles/sharedStyles";

import { Post } from "./Post/Post";
import {
  ErrorMessage,
  PostsList,
  Tag,
  TagsContainer,
} from "./styles";

export const Blog = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );

  const {
    posts,
    loading: loadingPosts,
    error: errorPosts,
  } = useSelector((state: RootState) => state.posts);

  const {
    postCategories,
    loading: loadingPostCategories,
    error: errorPostCategories,
  } = useSelector((state: RootState) => state.postCategories);

  useEffect(() => {
    dispatch(getPosts());
    dispatch(getPostCategories());
  }, [dispatch]);

  if (loadingPosts || loadingPostCategories) {
    return <Loader />;
  }

  if (errorPosts || errorPostCategories) {
    return <div>Error: {errorPosts}</div>;
  }

  const handleCategoryClick = (id: number | null) => {
    setSelectedCategoryId(id);
  };

  const handlePostClick = (id: number) => {
    navigate(`/blog/${id}`);
  };

  return (
    <Section>
      <TitleH1>Блог</TitleH1>
      {Array.isArray(postCategories) && postCategories.length > 0 ? (
        <TagsContainer>
          <Tag
            onClick={() => handleCategoryClick(null)}
            isActive={selectedCategoryId === null}
          >Все
          </Tag>
          {postCategories.map((category) => (
            <Tag
              key={category.id}
              onClick={() => handleCategoryClick(category.id)}
              isActive={selectedCategoryId === category.id}
            >
              {category.name}
            </Tag>
          ))}
        </TagsContainer>
      ) : (
        <ErrorMessage>Таких постов нет</ErrorMessage>
      )}
      {Array.isArray(posts) && posts.length > 0 ? (
        <PostsList>
          {posts
            .filter((post) => {
              if (selectedCategoryId === null) return true;

              return post.tags.some((tag) => tag.id === selectedCategoryId);
            })
            .map((post) => {
              return (
                <Post
                  onClick={handlePostClick}
                  key={post.id}
                  postImg={post.img}
                  postTitle={post.title}
                  postCreatedAt={post.created_at}
                  postTags={post.tags}
                  postId={post.id}
                />
              );
            })}
        </PostsList>
      ) : (
        <ErrorMessage>Таких постов нет</ErrorMessage>
      )}
    </Section>
  );
};

